import React, { useCallback, useContext, useEffect, useState } from 'react';
import './styles.css';
import { GoogleMap, MarkerF, PolygonF, InfoWindowF } from '@react-google-maps/api';
import { GlobalContext } from '../../contexts/HomeContext';
import { FormataValor } from '../../utils/utils';

export const Mapa = () => {
  const { dadosApp } = useContext(GlobalContext);
  const [area, setArea] = useState([]);
  const modalContent = document.querySelector('.modal-content');

  const containerStyle = {
    width: modalContent?.offsetWidth, // pegar o tamanho do modal-content
    height: '100vh',
  };

  const center = {
    lat: parseFloat(dadosApp.Empresa.Empresa.latitude.replace(',', '.')),
    lng: parseFloat(dadosApp.Empresa.Empresa.longitude.replace(',', '.')),
    title: '',
  };

  const handleMap = useCallback(() => {
    const _area = dadosApp.Empresa.Area.map((item) => {
      const areaAtendimento = [];
      const arrayCoordenadas = item.area.split('|');
      arrayCoordenadas.forEach((coordenada) => {
        const latLng = coordenada.split(',');
        areaAtendimento.push({
          lat: parseFloat(latLng[0]),
          lng: parseFloat(latLng[1]),
          val: item.valor,
        });
      });
      return { area: areaAtendimento };
      //area.push({ area: areaAtendimento });
    });
    setArea(_area);
  }, [dadosApp.Empresa.Area]);

  useEffect(() => {
    handleMap();
  }, [handleMap]);

  return (
    // <LoadScript googleMapsApiKey="AIzaSyDZiwAcckLZvMeXzy180FBMrbtFt4xhTy0">
    <GoogleMap mapContainerStyle={containerStyle} center={{ lat: center.lat, lng: center.lng }} zoom={14}>
      <MarkerF position={center} title={dadosApp.Empresa.Empresa.fantasia}></MarkerF>

      {area.map((i, index) => (
        <div key={index}>
          <PolygonF path={i.area}></PolygonF>
          {dadosApp.Empresa.Config.taxa_tipo == 'Regiao' && (
            <InfoWindowF
              position={{
                lat: i.area[1].lat,
                lng: i.area[1].lng,
                title: i.area[0].val,
              }}
              visible={false}
            >
              <span style={{ fontWeight: 'bold' }}>{FormataValor(i.area[0].val)}</span>
            </InfoWindowF>
          )}
          {dadosApp.Empresa.Config.taxa_tipo == 'Região' && (
            <InfoWindowF
              position={{
                lat: i.area[2].lat,
                lng: i.area[1].lng,
                title: i.area[0].val,
              }}
              visible={false}
            >
              <span style={{ fontWeight: 'bold' }}>{FormataValor(i.area[0].val)}</span>
            </InfoWindowF>
          )}
        </div>
      ))}
    </GoogleMap>
    // </LoadScript>
  );
};
